import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakTypeEnum,
  PlannedBreakFragment,
} from 'generated/resources/graphql'
import { computed, makeObservable } from 'mobx'

export default class PlannedBreak {
  id: number
  startAt: string | null
  endAt: string | null
  duration: number | undefined | null
  breakType: BreakTypeEnum
  breakConfiguration: BreakConfigurationFragment | null
  breakConfigurationPaid: boolean | undefined
  breakConfigurationName: string | null
  defaultShiftId?: number | null
  shiftConfigurationId?: number | null
  shiftId?: number | null
  dayConfigurationId?: number | null

  constructor(plannedBreak: PlannedBreakFragment) {
    this.id = plannedBreak.id
    this.startAt = plannedBreak.startAt
    this.endAt = plannedBreak.endAt
    this.duration = plannedBreak.duration
    this.breakType = plannedBreak.breakType
    this.breakConfiguration = plannedBreak.breakConfiguration || null
    this.breakConfigurationPaid = plannedBreak.breakConfigurationPaid
    this.breakConfigurationName = plannedBreak.breakConfigurationName
    // Ideally, these fields will be deprecated/unused
    // when we migrate everything to GraphQL nesting resources
    // Try to use relationships instead of these fields if they are needed.
    this.defaultShiftId = plannedBreak.defaultShiftId
    this.shiftId = plannedBreak.shiftId
    this.shiftConfigurationId = plannedBreak.shiftConfigurationId
    this.dayConfigurationId = plannedBreak.dayConfigurationId

    makeObservable(this, {
      isArchived: computed,
      isActive: computed,
      isFlexible: computed,
      isFixed: computed,
      isSemiFlexible: computed,
      durationInSeconds: computed,
      isPaid: computed,
      isUnpaid: computed,
    })
  }

  get isArchived(): boolean {
    return !!this.breakConfiguration?.archived
  }

  get isActive() {
    return !this.isArchived
  }

  get isFlexible() {
    return this.breakType === 'flexible'
  }

  get isFixed() {
    return this.breakType === 'fixed'
  }

  get isSemiFlexible() {
    return this.breakType === 'semi_flexible'
  }

  get durationInSeconds(): number {
    return (this.duration || 0) * 60
  }

  get isPaid(): boolean {
    return this.breakConfigurationPaid || false
  }

  get isUnpaid(): boolean {
    return !this.isPaid
  }
}
